import { Grid2, Stack } from '@mui/material'
import React from 'react'
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialInput from '../../../components/MaterialInput'
import MaterialSelect from '../../../components/MaterialSelect'

const Basic = ({ basicDetails, handleBasicChange, handleNoOfPersonsChange,PersonsType}) => {
    return (
        <Grid2 container spacing={3} sx={{ padding: '10px' }}>
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction='column' spacing={1}>
                    <MaterialTypography variant='caption' color='text'>
                        Start Date<span style={{ color: 'red' }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                        label='Start Date'
                        type='date'
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                        value={basicDetails.startDate}
                        onChange={(e) => handleBasicChange('startDate', e.target.value)}
                    />
                </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction='column' spacing={1}>
                    <MaterialTypography variant='caption' color='text'>
                        No. of persons<span style={{ color: 'red' }}>*</span>
                    </MaterialTypography>
                    <MaterialSelect
                        // label='No. of persons'
                        // fullWidth
                        // InputLabelProps={{ shrink: true }}
                        // variant='outlined'
                        option={PersonsType}
                        // value={basicDetails.noOfPersons}
                        // onChange={handleNoOfPersonsChange}
                    />
                </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction='column' spacing={1}>
                    <MaterialTypography variant='caption' color='text'>
                        Employee ID<span style={{ color: 'red' }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                        label='Employee ID'
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                        value={basicDetails.employeeID}
                        onChange={(e) => handleBasicChange('employeeID', e.target.value)}
                    />
                </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction='column' spacing={1}>
                    <MaterialTypography variant='caption' color='text'>
                        EMI Amount<span style={{ color: 'red' }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                        label='EMI Amount'
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                        value={basicDetails.emiAmount}
                        onChange={(e) => handleBasicChange('emiAmount', e.target.value)}
                    />
                </Stack>
            </Grid2>
        </Grid2>
    )
}

export default Basic
